<template>
  <Loader v-if="loading" />    
  <Card>
    <template v-slot:title>
      <h3>Gestione Convocazioni</h3>
    </template>
    <template v-slot:content>
      <div>
        <Button @click="switchFuture" class="p-button-warning" :label="(onlyFuture)?'Eventi passati':'Eventi futuri'" style="float:right" />
        <Button @click="addBox" class="p-button-info" :label="(boxes.length==0)?'Nuovo evento':'Chiudi'" id="addboxbtn"/>
        <div v-for="(box, index) in boxes" :key="index" class="box p-5" ><br/>
          <div class="flex">
          <div class="p-field col-12 md:col-3"><label for="nome">Titolo</label>
            <InputText v-model="box.nome" placeholder="Titolo" :class="['inputfield w-full']"/>
            <small v-show="validationErrors.nome && submitted" class="p-error">Campo richiesto o errato.</small>     
          </div>
          <div class="p-field col-12 md:col-3">
            <label for="nome">Costo</label>
            <InputNumber v-model="box.costo" placeholder="Costo dell'evento" :class="['inputfield w-full']"/>
            <small v-show="validationErrors.costo && submitted" class="p-error">Campo richiesto o errato.</small>              

          </div>
          <div class="p-field col-12 md:col-3">
            <label for="nome">Luogo</label>
            <InputText v-model="box.luogo" placeholder="Luogo dell'evento" :class="['inputfield w-full']"/>
            <small v-show="validationErrors.luogo && submitted" class="p-error">Campo richiesto o errato.</small>              

          </div>
          <div class="p-field col-12 md:col-3">
            <label for="campionato">Campionato</label>
            <InputText v-model="box.campionato" placeholder="Campionato" :class="['inputfield w-full']"/>
          </div>
        </div>
          <div class='flex'>
              <div class="p-field col-12 md:col-2">
                <label>Data inizio evento</label><br>                   
                <Calendar :class="['inputfield w-full',{'p-invalid': validationErrors.data_inizio && submitted}]" v-model="box.data_inizio" dateFormat="dd/mm/yy" :maxDate="maxDate" @change="onChangeInput($event, 'data_inizio')" showIcon :showOnFocus="false"/>
                <small v-show="validationErrors.data_inizio && submitted" class="p-error">Selezione un giorno.</small>
              </div> 
              <div class="p-field col-12 md:col-2">
                <label>Ora inizio evento</label><br>   
                <Calendar v-model="box.time_in" timeOnly :stepMinute="30" :manualInput="false" @update:modelValue="onChangeInput($event, 'orario', 'in', index)"/>
                <small v-show="validationErrors.time_in && submitted" class="p-error">Seleziona un orario</small>
              </div> 
              <div class="p-field col-12 md:col-2">
                <label>Data fine evento</label><br>                   
                <Calendar :class="['inputfield w-full',{'p-invalid': validationErrors.data_fine && submitted}]" v-model="box.data_fine" dateFormat="dd/mm/yy" :maxDate="maxDate" @change="onChangeInput($event, 'data_fine')" showIcon :showOnFocus="false"/>
                <small v-show="validationErrors.data_fine && submitted" class="p-error">Selezione un giorno.</small>
              </div> 
              <div class="p-field col-12 md:col-2">
                <label>Ora fine evento</label><br>    
                <Calendar v-model="box.time_out" timeOnly :stepMinute="30" :manualInput="false" @update:modelValue="onChangeInput($event, 'orario', 'in', index)"/>
                <small v-show="validationErrors.time_out && submitted" class="p-error">Seleziona un orario</small>  
              </div> 
              <div class="p-field col-12 md:col-2">
                <label>Data disponibilità</label><br>                   
                <Calendar :class="['inputfield w-full',{'p-invalid': validationErrors.data_disp && submitted}]" v-model="box.data_disp" dateFormat="dd/mm/yy" :maxDate="maxDate" @change="onChangeInput($event, 'data_disponibilita')" showIcon :showOnFocus="false"/>
                <small v-show="validationErrors.data_disp && submitted" class="p-error">Selezione un giorno.</small>
              </div> 
              <div class="p-field col-12 md:col-2">
                <label>Ora disponibilità</label><br>    
                <Calendar v-model="box.time_disp" timeOnly :stepMinute="30" :manualInput="false" @update:modelValue="onChangeInput($event, 'orario', 'disponibilita', index)"/>
                <small v-show="validationErrors.time_disp && submitted" class="p-error">Seleziona un orario</small> 
              </div> 
          </div>
<div class="flex">
<div class="p-field col-12"><label for="nomte">Note</label><InputText v-model="box.note" placeholder="Informazioni aggiuntive" :class="['inputfield w-full']"/></div>
</div>
<div class="p-3 col-12">
              <label for="nome"><b>Seleziona i corsi per le convocazioni</b></label><br/>
              <div v-for="day in corsi" :key="day.id">
                <label>
                  <input type="checkbox" v-model="box.corsi[day.id]" :value="day.id"
                  
        :checked="box.corsi.includes(day.id)"
         @change="toggleSelection(day.id)" />
                  {{ day.nome }}
                </label>
              </div>

            </div>
          <Button  class="p-button-success"  icon="pi pi-check" @click="saveBox(index)" label="Salva"/>
        </div>
       <div class="pt-3">
  <div class="p-3 mb-4 card"> <div class="flex align-items-center gap-3"> <label for="filtroGruppo" class="font-bold">Filtra per gruppo:</label>
      <Dropdown 
        id="filtroGruppo"
        v-model="selectedGruppo" 
        :options="gruppiOptionsConTutti" 
        optionLabel="nome" 
        optionValue="id"
        filter
        placeholder="Seleziona un gruppo" 
        class="flex-grow-1 md:flex-grow-0" /> </div>
  </div>
  
  <DataTable :value="filteredTornei" class="p-datatable-gridlines p-datatable-sm"> 
    <Column field="nome" header="Nome" sortable>
  <template #body="slotProps">
    <span class="font-bold">{{ slotProps.data.nome }}</span>
  </template>
</Column>
    <Column field="data_fine" header="Fine" sortable></Column>
    <Column field="luogo" header="Luogo"></Column>
    <Column field="descrizione" header="Info"></Column>
    <Column field="gruppo" header="Gruppo" sortable></Column>
    <Column field="convocabili" header="# Convoc."></Column>
    <Column field="disponibili" header="# Disp."></Column>
    <Column field="convocati" header="# Conv."></Column>
   <Column header="Pubbl." style="text-align: center;">
      <template #body="slotProps">
        <i 
          :class="[
            'pi', 
            { 
              // Condizione aggiornata: verifica se è la stringa 'SI'
              'pi-check-circle text-green-500': slotProps.data.pubblicato === 'SI', 
              // Condizione aggiornata: verifica se è la stringa 'NO'
              'pi-times-circle text-red-500': slotProps.data.pubblicato === 'NO'
              // Puoi aggiungere qui 'pi-question-circle text-gray-500': slotProps.data.pubblicato !== 'SI' && slotProps.data.pubblicato !== 'NO' se devi gestire altri valori
            }
          ]"
          style="font-size: 1.25rem;"
          :title="slotProps.data.pubblicato === 'SI' ? 'Pubblicato' : 'Non Pubblicato'"
        ></i>
      </template>
    </Column>
    <Column header="Azioni" style="text-align: center; width: 350px;">
      <template #body="slotProps">
        <div class="flex justify-content-center gap-2"> 
            <Button 
                @click="$router.push(`/torneo/${slotProps.data.id}/dettagli`)"
                label="Dettaglio"
                icon="pi pi-eye"
                class="p-button-sm p-button-info" />
            <Button 
            @click="openDialog(slotProps.data.id)"
            label="Gestisci"
            icon="pi pi-cog"
            class="p-button-sm p-button-warning" />
            
          <Button 
            @click="showDistinta(slotProps.data.id)"
            label="Distinta"
            icon="pi pi-list"
            class="p-button-sm p-button-info" />
            
          <Button 
            @click="openDialogPagamenti(slotProps.data.id)"
            label="Pagamenti"
            icon="pi pi-wallet"
            v-if="slotProps.data.convocati > 0"
            class="p-button-sm p-button-danger" />
        </div>
      </template>  
    </Column>
  </DataTable>
</div>
      </div>
    </template>
  </Card>





  <div v-if="confirmDialog.visible" class="confirm-dialog">
    <div class="confirm-dialog-content ">
      <h3>Gestione convocazione</h3>
      <div class="grid">
        <div class='col-12'> <label>
                  <input type="checkbox" 
                         v-model="item.stato" 
                         value="1" />
                 Pubblicata?
                </label></div>
        <div class="col-3">
          <label for="nome">Nome</label>
          <InputText v-model="item.nome" :class="['inputfield w-full']" />

        </div>

        <div class="col-1">
          <label for="nome">Costo</label>
          <InputText v-model="item.costo" :class="['inputfield w-full']" />

        </div>
        <div class="col-5">
          <label for="nome">Luogo</label>
          <InputText v-model="item.luogo" :class="['inputfield w-full']" />

        </div>
        <div class="col-3">
          <label for="nome">Note</label>
          <InputText v-model="item.descrizione" :class="['inputfield w-full']" />

        </div>
        <div class="col-3">
          <label for="campionato">Campionato</label>
          <InputText v-model="item.campionato" :class="['inputfield w-full']" />
        </div>
        <div class="col-3">
            <label>Data disponibilità</label><br>                   
            <Calendar :class="['inputfield w-full']" v-model="item.data_disp" dateFormat="dd/mm/yy" :maxDate="maxDate" showIcon :showOnFocus="false"/>
        </div> 
        <div class="col-3">
            <label>Ora disponibilità</label><br>    
            <Calendar v-model="item.time_disp" timeOnly :stepMinute="30" :manualInput="false" />
        </div>
        <div class="col-12">
          <label for="nome"><b>Convocazioni</b><br/></label>
          <DataTable :value="item.people" class="p-datatable-gridlines">
            <Column field="atleta" header="Atleta">
              <template #body="slotProps">  
                <span class="font-bold">{{ capitalize(slotProps.data.atleta) }}</span>  
              </template>
              </Column>
            <Column field="datadinascita" header="Data di nascita"></Column>
            <Column field="presenze_ultimi_due_mesi" header="Presenze ultimi 2 mesi"></Column>
            <Column field="convocazioni_ultimi_due_mesi" header="Convocazioni ultimi 2 mesi"></Column>
            <Column field="confermato" header="Disponibile"></Column>
            <Column field="data_conferma" header="Data disponibilità"></Column>
            <Column field="numero_maglia" header="N. Maglia">
              <template #body="slotProps">
                <InputText 
                  v-model="slotProps.data.numero_maglia" 
                  type="number"
                  placeholder="#"
                  style="width: 60px;"
                  @blur="saveNumeroMaglia(slotProps.data.id_atleta, slotProps.data.numero_maglia)"
                />
              </template>
            </Column>
            <Column style="text-align: right" header='Convoca'>
              <template #body="slotProps">
                <label>
                  <input type="checkbox" 
                         v-model="convocati" 
                         :value="slotProps.data.id" />
                  {{ slotProps.data.nome }}
                </label>
              </template>   
            </Column>
        </DataTable>
        </div>
        
        <!-- Staff Reimbursements Section -->
        <div class="col-12 mt-4">
          <h4>Rimborsi Staff</h4>
          
          <!-- Existing Reimbursements Table -->
          <DataTable v-if="staffReimbursements.length > 0" :value="staffReimbursements" class="p-datatable-sm mb-3">
            <Column field="nome" header="Staff"></Column>
            <Column field="amount" header="Importo (€)">
              <template #body="slotProps">
                € {{ parseFloat(slotProps.data.amount).toFixed(2) }}
              </template>
            </Column>
            <Column header="Azioni" style="width: 100px">
              <template #body="slotProps">
                <Button 
                  icon="pi pi-trash" 
                  class="p-button-danger p-button-sm" 
                  @click="deleteReimbursement(slotProps.data.id)"
                />
              </template>
            </Column>
          </DataTable>

          <!-- Add New Reimbursement Form -->
          <div class="grid mt-3">
            <div class="col-6">
              <label>Seleziona Staff</label>
              <Dropdown 
                v-model="selectedStaff" 
                :options="allStaff" 
                optionLabel="nome" 
                placeholder="Seleziona staff"
                class="w-full"
              />
            </div>
            <div class="col-4">
              <label>Importo (€)</label>
              <InputNumber 
                v-model="reimbursementAmount" 
                mode="currency" 
                currency="EUR" 
                locale="it-IT"
                class="w-full"
              />
            </div>
            <div class="col-2 flex align-items-end">
              <Button 
                label="Aggiungi" 
                icon="pi pi-plus" 
                @click="addReimbursement"
                :disabled="!selectedStaff || !reimbursementAmount"
              />
            </div>
          </div>
        </div>

        <div class="col-12 mt-4" v-if="isStripe">
        <h4>Link di Pagamento Stripe</h4>
        <div class="flex gap-2">
          <Button 
            label="Genera Link Pagamento per Convocati" 
            icon="pi pi-link" 
            class="p-button-success"
            @click="generatePaymentLinkDialog"
            :disabled="!item.costo || item.costo <= 0"
          />
          <Button 
            v-if="paymentLinksGenerated"
            label="Invia Email ai Convocati" 
            icon="pi pi-envelope" 
            class="p-button-info"
            @click="sendEmailsToConvocated"
          />
        </div>
        <div v-if="paymentLinksStats" class="mt-3 p-3" style="background-color: #f8f9fa; border-radius: 4px;">
          <p class="mb-2"><strong>Statistiche Link di Pagamento:</strong></p>
          <p class="mb-1">✅ Link creati: {{ paymentLinksStats.created }}</p>
          <p class="mb-1">📋 Link già esistenti: {{ paymentLinksStats.existing }}</p>
          <p v-if="paymentLinksStats.errors && paymentLinksStats.errors.length > 0" class="mb-0 text-danger">
            ❌ Errori: {{ paymentLinksStats.errors.length }}
          </p>
        </div>
      </div>
      <br />
      </div>
      <br />
      <div class="flex justify-content-between">
        <Button 
          v-if="isTorneoFuturo" 
          @click="showDeleteConfirmation" 
          label="Cancella" 
          icon="pi pi-trash"
          class="p-button-danger" 
        />
        <div class="flex gap-2">
          <Button @click="confirmDialogAccept" label="Salva" />
          <Button @click="confirmDialogReject" label="Annulla" class="p-button-secondary" />
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Dialog -->
  <div v-if="deleteConfirmDialog.visible" class="confirm-dialog">
    <div class="confirm-dialog-content" style="max-width: 400px;">
      <h3>Conferma Cancellazione</h3>
      <p>Sei sicuro di voler cancellare questo torneo?</p>
      <p class="text-danger"><strong>Questa azione non può essere annullata.</strong></p>
      <br />
      <div class="flex gap-2 justify-content-center">
        <Button @click="confirmDelete" label="Sì, Cancella" class="p-button-danger" />
        <Button @click="cancelDelete" label="Annulla" class="p-button-secondary" />
      </div>
    </div>
  </div>



  <div v-if="confirmDialogPaga.visible" class="confirm-dialog">
    <div class="confirm-dialog-content ">
      <h3>Gestione pagamenti convocazioni</h3>
      <div class="grid">
      
        

        <div class="p-3 col-6">
          <label for="nome">Costo</label>
          <InputText v-model="item.costo" :class="['inputfield w-full']" />
        </div>
        
        <div class="p-3 col-12">
          <Button 
            label="📧 Invia Promemoria Non Paganti" 
            class="p-button-warning"
            icon="pi pi-envelope"
            @click="sendPaymentReminder"
          />
        </div>
       
        <div class="p-3 col-12">
          <label for="nome"><b>Convocati</b><br/></label>
          <DataTable :value="convocatipaga" class="p-datatable-gridlines">
            <Column field="atleta" header="Atleta">
              <template #body="slotProps">
                <span class="font-bold">{{ capitalize(slotProps.data.atleta) }}</span>
              </template>
              </Column>
            <Column field="datadinascita" header="Data di nascita"></Column>
            <Column field="confermato" header="Disponibile"></Column>
            <Column field="data_conferma" header="Data disponibilità"></Column>
            <Column field="importo" header="Da pagare"></Column>
            <Column field="importo_pagato" header="Pagato"></Column>
            <Column header="Link Pagamento" style="min-width: 200px">
              <template #body="slotProps">
                <div v-if="slotProps.data.stripe_payment_link_url" class="flex gap-2 align-items-center">
                  <InputText 
                    :value="slotProps.data.stripe_payment_link_url" 
                    readonly 
                    class="flex-1"
                    style="font-size: 11px; padding: 0.3rem;"
                  />
                  <Button 
                    icon="pi pi-copy" 
                    class="p-button-sm p-button-secondary"
                    @click="copyAthletePaymentLink(slotProps.data.stripe_payment_link_url, slotProps.data.atleta)"
                    v-tooltip.top="'Copia link'"
                  />
                </div>
                <span v-else class="text-muted" style="font-size: 12px;">Nessun link</span>
              </template>
            </Column>
            <Column field="importo_pagato" header="">
              <template #body="slotProps">
                <label>
                  <Button @click="aggiungiDaPagare(slotProps.data.id_atleta,item.costo)" v-if="!slotProps.data.importo" label="Aggiungi da pagare"></Button>

                </label>
              </template>   
              </Column>
            
        </DataTable>
        </div>
        <br />
      </div>
      <br />
      <Button @click="confirmDialogPagaReject" label="Chiudi" class="p-button-secondary" />
    </div>
  </div>


</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import moment from 'moment'
import { useToast } from 'primevue/usetoast';

import services from '@/config/services.js'

export default {
  components: {
    Loader,
  },
  methods: {
    
  },
  setup () { 
    const self = getCurrentInstance();
    const toast = useToast();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const submitted = ref(false)
    const loading = ref(false)
    const isStripe = ref(process.env.VUE_APP_IS_STRIPE === 'true')
   
    const validationErrors = ref({})
    const types = ref()
    const responsabili = ref()
    const date = moment();
    const minDateInizio = ref();
    const maxDateInizio = ref();
    const minDateFine = ref();
    const tornei = ref();
    const torneiToShow= ref([]);
    const maxDateFine = ref();
    const buttonDays = ref([])
    const boxes = ref([])
    const citta = ref([])
    const corsi = ref()
    const selectedGruppo = ref(null)

    const item = ref()
    const onlyFuture = ref(true)
    const corso = ref([])
    const convocati = ref([])
    const convocatipaga = ref([])
    const staffReimbursements = ref([])
    const allStaff = ref([])
    const selectedStaff = ref(null)
    const reimbursementAmount = ref(0)
    const paymentLinksGenerated = ref(false)
    const paymentLinksStats = ref(null)
    const lifeTime = 3000
    const confirmDialog = ref({
      visible: false,
      id: null,
      visibile: null,
      selectedCorso: null
    });
    const deleteConfirmDialog = ref({
      visible: false
    });
    const isTorneoFuturo = ref(false);
    const confirmDialogPaga = ref({
      visible: false,
      id: null,
      visibile: null,
      selectedCorso: null
    });
    const toggleSelection=(id)=> {
      const index = corso.value.indexOf(id);
      if (index === -1) {
        // Se l'ID non è nell'array, aggiungilo
        corso.value.push(id);
      } else {
        // Se l'ID è già nell'array, rimuovilo
        corso.value.splice(index, 1);
      }
    }
    const filteredTornei = computed(() => {
      console.log("filteredTornei")
      console.log(selectedGruppo.value)
      if (!selectedGruppo.value) return torneiToShow.value
      return torneiToShow.value.filter(t => t.gruppo_id.includes(selectedGruppo.value))
    })
    const switchFuture =()=>{
      onlyFuture.value=!onlyFuture.value
      syncDataToShow()
    }

    const syncDataToShow=()=>{
      torneiToShow.value=[]
      tornei.value.forEach( p => {
          
          if (moment(p.data_inizio)>moment.now() && onlyFuture.value){
            torneiToShow.value.push(p)
          }
          if (moment(p.data_inizio)<moment.now() && !onlyFuture.value){
            torneiToShow.value.push(p)
          }
        })
        loading.value=false
    }
    const gruppiOptionsConTutti = computed(() => [
      { id: null, nome: 'Tutti i gruppi' },
      ...(corsi.value || [])
    ])
    const toggleSelectionConvocati=(person)=> {
      console.log("toggleSelectionConvocati")
      console.log(person)
      const index = convocati.value.findIndex(item => item.id === person.id);
      console.log(index)
      if (index === -1) {
        // Se l'ID non è nell'array, aggiungilo
        convocati.value.push(person);
      } else {
        // Se l'ID è già nell'array, rimuovilo
        convocati.value.splice(index, 1);
      }
      console.log(convocati.value)
    }

    const confirmDialogPagaReject = () =>{
      confirmDialogPaga.value.visible = false;

    }
    const confirmDialogReject = () =>{
      confirmDialog.value.visible = false;

    }
    const confirmDialogAccept = () =>{
        console.log(convocati.value)

        let fd = new FormData();
        var box={}
        box.convocati=convocati.value
        box.id=item.value.id
        box.nome=item.value.nome
        box.luogo=item.value.luogo
        box.costo=item.value.costo
        box.note=item.value.descrizione
        box.stato=item.value.stato?'1':'0'
        
        if (item.value.data_disp) {
            box.disponibilita = moment(item.value.data_disp).format('YYYY-MM-DD');
        }
        if (item.value.time_disp) {
             let hours = item.value.time_disp.getHours().toString().padStart(2,'0');
             let minutes = item.value.time_disp.getMinutes().toString().padStart(2,'0');
             box.time_disponibilita = `${hours}:${minutes}:00`;
        }
        fd.append('torneo', JSON.stringify(box));
        
        service.saveConvocazione(fd)
        .then((res) => {
          let severity = res.item.esito
          let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
          let detail = res.item.messaggio
          
          if (severity != 'warning') {
            toast.add({severity:severity, summary: summary, detail:detail, life: lifeTime});   
                    
          }

        }).finally(()=>{
          service.getTornei().then((res)=>{
            tornei.value=res.items;
            syncDataToShow()
          })

        })




      confirmDialog.value.visible = false;

    }

    const openDialogPagamenti = (id) =>{
      service.getDetailTorneo(id)
        .then((res) => {
          convocatipaga.value=[]
          item.value=res.items;
          item.value.people.forEach( p => {
            p.confermato = p.confermato==0?'In attesa':p.confermato==1?'SI':'NO'
            if (p.convocato){
              convocatipaga.value.push(p)
            }
            p.datadinascita=moment(p.datadinascita).format('DD/MM/YYYY')
          })
          item.value.stato==0?item.value.stato=false:item.value.stato=true
          console.log(item.value);
          confirmDialogPaga.value.visible = true;
          confirmDialogPaga.value.id = id;

        })
    }
    const aggiungiDaPagare = (userId,costo)=>{

      let fd = new FormData();
        fd.append("userId",userId);
        fd.append("torneo",confirmDialogPaga.value.id);
        fd.append("costo",costo);
        
      service.aggiungiDaPagareTorneo(fd).then((res)=>{
        item.value.people.forEach( p => {
          if (p.id_atleta==userId){
            p.importo=costo
          }
        })
        let severity = res.item.esito
          let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
          let detail = res.item.messaggio
          
          if (severity != 'warning') {
            toast.add({severity:severity, summary: summary, detail:detail, life: lifeTime});   
                    
          }
      })
    }


    const openDialog = async (id) =>{
      const res = await service.getDetailTorneo(id)
      convocati.value=[]
      paymentLinksGenerated.value = false // Reset payment links
      paymentLinksStats.value = null
      item.value=res.items;
      item.value.people.forEach( p => {
        p.confermato = p.confermato==0?'In attesa':p.confermato==1?'SI':'NO'
        if (p.convocato){
          convocati.value.push(p.id)
        }
        p.datadinascita=moment(p.datadinascita).format('DD/MM/YYYY')
      })
      item.value.stato==0?item.value.stato=false:item.value.stato=true
      
      // Check if tournament is in the future
      isTorneoFuturo.value = moment(item.value.data_inizio).isAfter(moment())
      
      console.log(item.value);
      if (item.value.data_disponibilita) {
          item.value.data_disp = moment(item.value.data_disponibilita).toDate();
          item.value.time_disp = moment(item.value.data_disponibilita).toDate();
      }
      confirmDialog.value.visible = true;
      confirmDialog.value.id = id;

      // Load reimbursements and staff
      await loadReimbursements(id)
      await loadAllStaff()
    }

    const onChangeInput = (evt, prop) => {
      let value
      switch (prop) {
        case 'id_utente':
        value = evt.value
        break;
        
        default:
        value = evt.target.value
        break;
      }
      if (value == '' || value == null) {
        validationErrors.value[prop] = true
      }else{
        delete validationErrors.value[prop]
      }
    }
    const validateForm = (box) => {
      // Validazione corso
      let validate_properties = [
        'nome',
        'data_inizio',
        'data_fine',
        'time_in',
        'time_out',
        'data_fine',
        'data_disp',
        'time_disp',
        'luogo'
      ]
      
      validate_properties.forEach( prop => {
        let check
        switch (prop) {
          
          default:
            check = box[prop] == '' || box[prop] == null
        }
        if (check) {
          validationErrors.value[prop] = true
        } else {
          delete validationErrors.value[prop];
        }
      })
      
      
      return !Object.keys(validationErrors.value).length;
    }


    const addBox = () => {
      if (boxes.value.length==0){
       
      boxes.value.push({
        nome: '',
        luogo: '',
        costo:0,
        data_inizio:null,
        data_fine:null,
        corsi:[]
      });
    }else{
      boxes.value.pop();
    }
    }
    const setTime = (el) => {
      let hours = el.getHours().toString().padStart(2,'0');
      let minutes = el.getMinutes().toString().padStart(2,'0');
      return `${hours}:${minutes}:00`
    }
    const saveBox = (index) => {
      submitted.value=true
      const box = boxes.value[index];
      if (validateForm(box)){
      // Implementa la logica di salvataggio dei dati del box qui
        console.log('Saving box', index, box);
        let fd = new FormData();
        box.inizio=moment(box.data_inizio, 'DD/MM/YYYY').format('YYYY-MM-DD')
        box.fine=moment(box.data_fine, 'DD/MM/YYYY').format('YYYY-MM-DD')

        box.disponibilita=moment(box.data_disp, 'DD/MM/YYYY').format('YYYY-MM-DD')
        box.time_disponibilita=setTime(box.time_disp)
        box.in=setTime(box.time_in)
        box.out=setTime(box.time_out)
        box.corsi=corso;
        fd.append('torneo', JSON.stringify(box));
        
        service.sendTorneo(fd)
        .then((res) => {
          let severity = res.item.esito
          let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
          let detail = res.item.messaggio
          
          if (severity != 'warning') {
            toast.add({severity:severity, summary: summary, detail:detail, life: lifeTime});   
            boxes.value.pop(); 
            corso.value=[]               
          }

        }).finally(()=>{
        })
      }else{
        toast.add({severity:'warn', summary: 'Attenzione', detail:`Ci sono dei dati mancanti`});
      }
    }

    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      boxes.value[index].image = file;
    }

    const showDistinta = (id) => {
      window.open(`${services.levante_api.url}/stampa-distinta-torneo/${id}`, '_blank');
    }

    
    const initData = () => {
      // restart var
      loading.value = true
      service.getTornei().then((res)=>{
        tornei.value=res.items;
        syncDataToShow()
      })

      service.getCorsiAttivi().then((res)=>{
        corsi.value=res.items
      })
    }
 
    const capitalize = (str) => {
      if (!str) return '';
      return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    };

    const saveNumeroMaglia = (idAtleta, numeroMaglia) => {
      let fd = new FormData();
      fd.append("id_torneo", confirmDialog.value.id);
      fd.append("id_atleta", idAtleta);
      fd.append("numero_maglia", numeroMaglia || "");
      
      service.saveNumeroMaglia(fd).then((res) => {
        if (res.item.esito === 'success') {
          toast.add({severity:'success', summary: 'Successo', detail:'Numero maglia salvato', life: lifeTime});
        }
      });
    }

    // Reimbursement methods
    const loadReimbursements = async (convocationId) => {
      const response = await service.getConvocationReimbursements(convocationId)
      if (response.items && response.items.status) {
        staffReimbursements.value = response.items.data || []
      }
    }

    const loadAllStaff = async () => {
      const response = await service.getAllStaff()
      if (response.items && response.items.status) {
        allStaff.value = response.items.data || []
      }
    }

    const addReimbursement = async () => {
      if (!selectedStaff.value || !reimbursementAmount.value) return
      
      staffReimbursements.value.push({
        mister_id: selectedStaff.value.id,
        nome: selectedStaff.value.nome,
        amount: reimbursementAmount.value
      })
      
      await saveAllReimbursements()
      selectedStaff.value = null
      reimbursementAmount.value = 0
    }

    const deleteReimbursement = async (id) => {
      await service.deleteConvocationReimbursement(id)
      staffReimbursements.value = staffReimbursements.value.filter(r => r.id !== id)
      toast.add({severity:'success', summary:'Successo', detail:'Rimborso eliminato', life: lifeTime})
    }

    const saveAllReimbursements = async () => {
      const reimbursements = staffReimbursements.value.map(r => ({
        mister_id: r.mister_id,
        amount: r.amount
      }))
      
      await service.saveConvocationReimbursements(item.value.id, reimbursements)
      await loadReimbursements(item.value.id)
      toast.add({severity:'success', summary:'Successo', detail:'Rimborsi salvati', life: lifeTime})
    }

    const generatePaymentLinkDialog = async () => {
      if (!item.value.costo || item.value.costo <= 0) {
        toast.add({severity:'warn', summary:'Attenzione', detail:'Inserisci un costo valido per il torneo', life: lifeTime})
        return
      }

      try {
        const res = await service.generatePaymentLink(confirmDialog.value.id, item.value.costo)
        
        if (res.item.esito === 'success') {
          paymentLinksGenerated.value = true
          paymentLinksStats.value = {
            created: res.item.links_created || 0,
            existing: res.item.links_existing || 0,
            errors: res.item.errors || []
          }
          toast.add({severity:'success', summary:'Successo', detail:res.item.messaggio, life: lifeTime})
        } else {
          toast.add({severity:'error', summary:'Errore', detail:res.item.messaggio, life: lifeTime})
        }
      } catch (error) {
        toast.add({severity:'error', summary:'Errore', detail:'Errore nella generazione dei link', life: lifeTime})
      }
    }

    const sendEmailsToConvocated = async () => {
      if (!paymentLinksGenerated.value) {
        toast.add({severity:'warn', summary:'Attenzione', detail:'Genera prima i link di pagamento', life: lifeTime})
        return
      }

      try {
        const res = await service.sendConvocationEmails(confirmDialog.value.id)
        
        if (res.item.esito === 'success') {
          toast.add({severity:'success', summary:'Successo', detail:res.item.messaggio, life: lifeTime})
        } else {
          toast.add({severity:'error', summary:'Errore', detail:res.item.messaggio, life: lifeTime})
        }
      } catch (error) {
        toast.add({severity:'error', summary:'Errore', detail:'Errore nell\'invio delle email', life: lifeTime})
      }
    }

    const copyAthletePaymentLink = (link, athleteName) => {
      if (link) {
        navigator.clipboard.writeText(link)
        toast.add({severity:'success', summary:'Copiato!', detail:`Link di ${athleteName} copiato`, life: 2000})
      }
    }

    const showDeleteConfirmation = () => {
      deleteConfirmDialog.value.visible = true
    }

    const cancelDelete = () => {
      deleteConfirmDialog.value.visible = false
    }

    const confirmDelete = async () => {
      try {
        let fd = new FormData()
        fd.append('id_torneo', confirmDialog.value.id)
        
        const res = await service.deleteTorneo(fd)
        
        if (res.item.esito === 'success') {
          toast.add({severity:'success', summary:'Successo', detail:res.item.messaggio, life: lifeTime})
          deleteConfirmDialog.value.visible = false
          confirmDialog.value.visible = false
          
          // Refresh tournament list
          const torneiRes = await service.getTornei()
          tornei.value = torneiRes.items
          syncDataToShow()
        } else {
          toast.add({severity:'error', summary:'Errore', detail:res.item.messaggio, life: lifeTime})
        }
      } catch (error) {
        toast.add({severity:'error', summary:'Errore', detail:'Errore nella cancellazione del torneo', life: lifeTime})
      }
    }

    
    onMounted(() => { 
      initData()
    })
    
    const sendPaymentReminder = async () => {
      try {
        const res = await service.sendPaymentReminderEmails(confirmDialogPaga.value.id)
        
        if (res.item.esito === 'success') {
          toast.add({severity:'success', summary:'Successo', detail:res.item.messaggio, life: lifeTime})
        } else {
          toast.add({severity:'error', summary:'Errore', detail:res.item.messaggio, life: lifeTime})
        }
      } catch (error) {
        toast.add({severity:'error', summary:'Errore', detail:'Errore nell\'invio dei promemoria', life: lifeTime})
      }
    }

    return {
      toggleSelection,capitalize,
      toggleSelectionConvocati,
      tornei,
      convocatipaga,
      convocati,
      loading,
      citta,
      submitted,
      validationErrors,
      types,
      moment,
      switchFuture,
      date,
      item,
      confirmDialog,
      minDateInizio,
      maxDateInizio,
      minDateFine,
      maxDateFine,
      buttonDays,
      confirmDialogPaga,
      isStripe,
      openDialog,
      openDialogPagamenti,
      addBox,
      saveBox,
      onFileChange,
      confirmDialogReject,confirmDialogAccept,
      confirmDialogPagaReject,
      boxes,
      torneiToShow,
      filteredTornei,
      corsi,
      aggiungiDaPagare,
      onChangeInput,
      selectedGruppo,
      gruppiOptionsConTutti,
      onlyFuture,
      showDistinta,
      saveNumeroMaglia,
      staffReimbursements,
      allStaff,
      selectedStaff,
      reimbursementAmount,
      addReimbursement,
      deleteReimbursement,
      paymentLinksGenerated,
      paymentLinksStats,
      generatePaymentLinkDialog,
      sendEmailsToConvocated,
      copyAthletePaymentLink,
      deleteConfirmDialog,
      isTorneoFuturo,
      showDeleteConfirmation,
      cancelDelete,
      confirmDelete,
      sendPaymentReminder
    }
  },
}
</script>

<style>
.text_toupper{
  text-transform: uppercase;
} 
</style>
<style scoped>
.counter{
  position:absolute;
  right:10px;
  top:10px;
}
#container-atleti{
  display: block;
}
.layout-main-container{
  width: fit-content !important;
}
.btn-error-filter{
  width: 200px;
}

.btn-campo{
  background:#ffffff url("/images/campo.jpg") no-repeat right top;
  background-size: contain;
  width: 100px;
  aspect-ratio:1 ;
}

.numero-campo{
  color: black;
  font-size: 40px;
  font-weight: 500;
  position: relative;
  z-index: 2;
}
.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  max-height: 90%;
  overflow-y: auto;
}

.confirm-dialog-content {
  text-align: center;
}

.confirm-dialog-content h3 {
  margin-top: 0;
}

.confirm-dialog-content button {
  margin: 10px;
}
</style>
